<template>
    <div class="diff-modal">
        <div class="preview">
            <div class="wanka-info">
                <wanka-info @getUrl="getWkUrl"/>
            </div>
            <div class="pk">
                <div class="icon" @click="handleShowDiff">PK</div>
            </div>
            <div class="media-info">
                <media-info  @getUrl="getMediaUrl"/>
            </div>
        </div>

        <div class="mt20" style="text-align: center;">
            <div>
                <el-button :disabled="loading" @click="handleCancel">取消</el-button>
                <el-button :loading="loading" type="primary" @click="handleSure">确定</el-button>
            </div>
        </div>

        <SliderImg v-if="show" :imgList="pkList" @close="handleClose"/>

    </div>
</template>
<script>
import WankaInfo from '../components/wankaInfo.vue'
import MediaInfo from '../components/mediaInfo.vue'
import SliderImg from '../components/sliderImg.vue'
import { compareSaveApi } from '@/api/systemTool/compare'
export default {
    name: 'diffModal',
    props: {
        cbs:{
            type:Object,
        },
    },
    components: {
        WankaInfo,
        MediaInfo,
        SliderImg
    },
    data() {
        return {
            show: false,
            pkList:[], // 数组两项 1 比对项目 2 被比对项目 
            wid: '',
            cid: '',
            plat_id: '',
            loading: false
        }
    },
    methods: {
        getWkUrl(params) {
            this.pkList[0] = params.material_url
            this.wid = params.wid
        },
        getMediaUrl(params) {
            this.pkList[1] = params.material_url
            this.cid = params.cid
            this.plat_id = params.plat_id
        },
        handleShowDiff() {
            if(!this.wid || !this.cid) {
                return this.$message.warning('请选择对比图片')
            }
            this.show = true
        },
        handleClose() {
            this.show = false
        },
        handleCancel() {
            this.$emit('close')
        },
        async handleSure() {
            if(!this.wid || !this.cid) return this.$message.warning('请选择对比图片')
            try {
                this.loading = true;
                await compareSaveApi({wid: this.wid, cid: this.cid, plat_id:this.plat_id})
                this.$message.success('插入比对成功')
                this.cbs.onSubmit()
            } catch (error) {
                this.$message.error(error.info)
            }finally {
                this.loading = false
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.diff-modal {
    width: 100%;
    .preview {
        max-height: 60vh;
        overflow-y: auto;
        display: flex;
        overflow-x: hidden;
        justify-content: space-between;
        position: relative;

        .wanka-info {
            // flex: 1;
            width: 47%;
        }

        .media-info {
            // flex: 1;
            width: 47%;
        }

        .pk {
            width: 6%;
            padding: 0 10px;
            text-align: center;
            padding-top: 35vh;
            

            .icon {
                cursor: pointer;
                border: 3px solid #66b1ff;
                border-radius: 50%;
                width: 40px;
                height: 40px;
                line-height: 36px;
                color: #66b1ff;
            }

        }
    }

}
</style>